import { StatusTypes, getValue } from '@chegg/commerce-utils';
import { saveConfigs } from '../../../redux/ConfigState/ConfigState.actions';
import { updateBillingAddress, updateFormFieldData } from '../../../redux/PaymentState/PaymentState.actions';
import { doFireStatusUpdate } from '../../../utils/CallbackUtils';
/**
 * Util to handle Verify Address command from User address
 * @param statusUpdate
 * @param dispatchAddressUpdate
 * @param dispatch
 * @param ui
 */
export var handleVerifyAddress = function handleVerifyAddress(params) {
  var statusUpdate = params.statusUpdate,
    dispatchAddressUpdate = params.dispatchAddressUpdate,
    dispatch = params.dispatch;
  var updatedDispatchAddressUpdateState = dispatchAddressUpdate;
  var status = statusUpdate.status;

  //TODO: figure out when/if this code runs. There are no VERIFY_ADDRESS success calls in user address.
  if (status === StatusTypes.SUCCESS) {
    var _zip$isMandatory, _zip$value;
    var payload = statusUpdate.payload;
    var _ref = payload.data,
      selectedCity = _ref.selectedCity,
      zip = _ref.zip,
      country = _ref.country; // TODO @vshah to export the payload from UA
    var isMandatory = (_zip$isMandatory = zip === null || zip === void 0 ? void 0 : zip.isMandatory) !== null && _zip$isMandatory !== void 0 ? _zip$isMandatory : false;
    var city = '',
      state = '';
    if (selectedCity) {
      // eslint-disable-next-line camelcase
      var state_abbreviation = selectedCity.state_abbreviation;
      city = getValue(selectedCity, 'city', '');
      // eslint-disable-next-line camelcase
      state = state_abbreviation ? getValue(selectedCity, 'state_abbreviation', '') : getValue(selectedCity, 'state', '');
    }
    dispatch(updateBillingAddress({
      city: city,
      state: state,
      zip: (_zip$value = zip === null || zip === void 0 ? void 0 : zip.value) !== null && _zip$value !== void 0 ? _zip$value : '',
      country: country.countryCode,
      isZipMandatory: isMandatory
    }));
    doFireStatusUpdate([statusUpdate]);
    if (dispatchAddressUpdate) {
      updatedDispatchAddressUpdateState = false;
      // if data provided by paypal/apple pay validate address flow, notify verifyAddress
      dispatch(saveConfigs({
        didAddressUpdate: true
      }));
    }

    // isDisabled property on the Payment Form sets true if it's false when the zip code field is valid
    dispatch(updateFormFieldData({
      userAddress: {
        error: ''
      }
    }));
    /* istanbul ignore next */
  } else if (status === StatusTypes.ERROR) {
    // sample payload: { error: { code: "ADDR-101", message: "Whatever" } }
    doFireStatusUpdate([statusUpdate]);

    // prevents to work the update card button if the zip code field is invalid
    dispatch(updateFormFieldData({
      userAddress: {
        error: statusUpdate.payload.errors[0].message
      }
    }));
  }
  return updatedDispatchAddressUpdateState;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/handleVerifyAddress.js
// module id = 4554
// module chunks = 11